module.exports = __webpack_public_path__ + "img/block_6.9457bb06.png";